var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.locale !== 'en')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.switchLang('en')}}},[_vm._v("English")]):_vm._e(),_vm._v(" "),(_vm.locale !== 'fr')?_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.switchLang('fr')}}},[_vm._v("Français")]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d47b107c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/LanguageSwitch.vue
// module id = 441
// module chunks = 0